module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-form"
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "发票抬头",
      "error": _vm.formValidate && !_vm.formData.taitou,
      "placeholder": "请输入发票抬头"
    },
    model: {
      value: (_vm.formData.taitou),
      callback: function($$v) {
        _vm.$set(_vm.formData, "taitou", $$v)
      },
      expression: "formData.taitou"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "税号",
      "error": _vm.formValidate && !_vm.formData.shuihao,
      "type": "number",
      "placeholder": "请输入税号"
    },
    model: {
      value: (_vm.formData.shuihao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "shuihao", $$v)
      },
      expression: "formData.shuihao"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "开户行及账号",
      "error": _vm.formValidate && !_vm.formData.account,
      "placeholder": "请输入开户行及账号"
    },
    model: {
      value: (_vm.formData.account),
      callback: function($$v) {
        _vm.$set(_vm.formData, "account", $$v)
      },
      expression: "formData.account"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "购买方地址",
      "error": _vm.formValidate && !_vm.formData.address,
      "placeholder": "请输入购买方地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "购买方电话",
      "error": _vm.formValidate && !_vm.formData.phone,
      "placeholder": "请输入购买方电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticClass: "save",
    attrs: {
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.formSave($event)
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px",
      "color": "#666",
      "text-align": "center"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("\n    删除\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.area_show),
      expression: "area_show"
    }],
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "1000",
      "width": "100%"
    }
  }, [_c('van-popup', {
    staticStyle: {
      "top": "50%"
    },
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area_key
    },
    on: {
      "confirm": _vm.areaConfirm,
      "cancel": _vm.areaCancel
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26f9f700","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/invoice/InvoiceEdit.vue
// module id = 2283
// module chunks = 0